<template>

</template>

<script>
  import mqtt from "mqtt";
  export default {
    data() {
      return {
        adm_tips_timer: null, //消息通知定时器
        adm_tips_date: null, //当前时间
        // mqtt 获取提示数据
        client: {
          connected: false,
        },
        retryTimes: 0,
        connection: {
          url: this.MqttUrl,
          clean: true,
          connectTimeout: 30 * 1000, // ms
          reconnectPeriod: 4000, // ms
          clientId: "vueXunLiaoAdmTips" + Math.random().toString(16).substring(2, 8),
          username: "xunliao",
          password: "123456",
        },
      }
    },

    mounted() {
      this.init();
    },
    methods: {
      // 获取最新消息通知
      init() {
        const _this = this
        if (localStorage.getItem('token') && this.$store.state.store_type == 1) {
          this.createConnection();
          // 开启定时器
          _this.adm_tips_timer = setInterval(() => {
            if (!localStorage.getItem('token') || parseInt(_this.$store.state.store_type) !== 1) {
              _this.close();
            }
          }, 1000);
        } else {
          this.close();
        }
      },
      //关闭消息通知定时器
      close() {
        clearInterval(this.adm_tips_timer)
        this.adm_tips_timer = null;
        // 断开连接
        this.destroyConnection();
      },
      initData() {
        this.client = {
          connected: false,
        };
        this.retryTimes = 0;
      },
      handleOnReConnect() {
        this.retryTimes += 1;
        if (this.retryTimes > 5) {
          try {
            this.client.end();
            this.initData();
            this.$Message.error("Connection maxReconnectTimes limit, stop retry");
          } catch (error) {
            this.$Message.error(error.toString());
          }
        }
      },
      // 创建mqtt 连接
      createConnection() {
        try {
          const _this = this;
          // 连接配置
          const {
            url,
            ...options
          } = this.connection;
          // 当前登录账号信息
          const userInfo = JSON.parse(localStorage.getItem('userInfo'));
          // 订阅主题
          const topic = 'xunliao/adm/tips/' + userInfo.store_id;
          // 创建连接
          this.client = mqtt.connect(url, options);
          if (this.client.on) {
            // 监听连接成功
            this.client.on("connect", () => {
              // console.log("adm_tips 连接成功");
              // 订阅主题
              _this.client.subscribe(topic, {
                qos: 0
              }, (error) => {
                if (error) {
                  console.log(error);
                }
              });
            });
            // 重新链接
            // this.client.on("reconnect", this.handleOnReConnect);
            // 连接失败
            this.client.on("error", (error) => {
              console.log("连接失败", error);
            });
            // 监听消息
            this.client.on("message", (topic, message) => {
              var uint8Msg = new Uint8Array(message);
              // 解码成字符串
              var decodedString = String.fromCharCode.apply(null, uint8Msg);
              // 转成json数据
              var data = JSON.parse(decodedString);
              _this.$Notice.warning({
                title: '新的消息提醒',
                desc: '<div style="color: red;">' + data.text + '</div>',
                duration: 5
              });
            });
          }
        } catch (error) {
          console.log("mqtt.connect error", error);
        }
      },
      // 断开连接
      destroyConnection() {
        const _this = this;
        if (this.client.connected) {
          try {
            _this.client.end(false, () => {
              _this.initData();
              console.log('断开连接');
            });
          } catch (error) {
            console.log('断开失败', error.toString());
          }
        }
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/public/AdmTips.vue